import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import {storeInstance} from '@aofl/store/dist/legacy';
import {modals, pages, exceptionCodes, sdoNs, userTypes} from '@modules/constants-enumerate';
import translations from '@modules/i18n';
import {SimpleModal} from '@modules/simple-modal';
import {ApiService} from '@modules/api-service';
import {Toast} from '@modules/toast';
import {routerInstance} from '@aofl/router';
import {isRequired, validationMixin} from '@aofl/form-validate';
import {emailLike} from '@modules/custom-form-validators';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import {toastStatus} from '@modules/i18n-labels';

/**
 * @summary UpdateLoginEmailModal
 * @extends {AoflElement}
 */
@customElement('update-login-email-modal')
class UpdateLoginEmailModal extends mapStatePropertiesMixin(validationMixin(i18nMixin(AoflElement))) {
  /**
   * Creates an instance of PasswordConfirmModal.
   */
  constructor() {
    super();
    this.translations = translations;

    this.validators = {
      email: {
        emailLike: (value) => {
          return (typeof value !== 'undefined') && emailLike(value) && value.trim() !== '';
        },
        same: (value) => {
          return value !== this.currentEmail;
        },
        conflicting: (value) => {
          return !value || !this.conflictingEmail || value !== this.conflictingEmail;
        }
      },
      password: {
        isRequired,
      }
    };
  }
  /**
   * @readonly
   */
  static is = 'update-login-email-modal';

  @property({type: Object, mapState: `${sdoNs.SIMPLE_MODAL}.modals.${modals.UPDATE_LOGIN_EMAIL}.data`, store: storeInstance})
  modalData = {};

  @property({type: String, mapState: `${sdoNs.SIMPLE_MODAL}.modals.${modals.UPDATE_LOGIN_EMAIL}.data.email`, store: storeInstance})
  currentEmail = '';

  @property({type: String, mapState: `${sdoNs.SESSION}.type`, store: storeInstance})
  userType = '';

  @property({type: String})
  password = '';

  @property({type: String})
  conflictingEmail = '';

  @property({type: Boolean})
  invalidCredentials = false;

  @property({type: Boolean})
  submitting = false;

  emailUpdated(e) {
    if (e.target.value.trim() !== this.email) {
      this.error = {};
    }

    this.email = e.target.value.trim();
    this.form.email.validate();
  }

  validateEmail(e) {
    this.form.email.validate();
  }

  async updatePassword(e) {
    this.password = e.target.value.trim();
    await this.form.password.validate();
    this.form.email.validate();
  }

  async submit(e) {
    this.submitting = true;
    let closeModal = true;
    e.preventDefault();
    e.stopPropagation();

    this.form.validate();
    await this.form.validateComplete;

    if (!this.form.valid) {
      this.submitting = false;
      return;
    }

    try {
      let data = {
        id: this.modalData.userId,
        email: this.email,
        password: this.password
      };

      if (this.userType === userTypes.PARENT) {
        await ApiService.parentUpdateLoginEmail(data);
        Toast.success(toastStatus.saveSuccess);
        routerInstance.navigate(pages.PARENT_PROFILE_EDIT, {forceReload: true});
      } else {
        if (this.modalData.mfaEnabled) {
          data = {...data, mfa_method: this.modalData.mfaMethod}
        }
        await ApiService.userUpdateLogin(data);
        Toast.success(toastStatus.saveSuccess);
        routerInstance.navigate(pages.MY_PROFILE, {forceReload: true});
      }
    } catch (e) {
      closeModal = false;
      if (e.error.code === exceptionCodes.AUTHENTICATION_GENERAL) {
        this.invalidCredentials = true;
      }
      if (
        e.error.code === exceptionCodes.INPUT_DUPLICATE_EMAIL
        ||
        e.error.code === exceptionCodes.INPUT_CONFLICTING_PRODUCT_CREDENTIALS
      ) {
        this.conflictingEmail = this.email;
        Toast.error(toastStatus.duplicateEmail);
      } else {
        Toast.error(toastStatus.oops);
      }
    } finally {
      this.submitting = false;
      // Close modal only if successful
      if(closeModal) {
        this.close();
      }
    }
  }

  close() {
    SimpleModal.hide();
  }

  firstUpdated(changedProperties) {
    this.shadowRoot.querySelector('[tabindex="0"]').focus();
  }


  /**
   * @return {Object}
   */
  render() {
    return super.render({
      default: {
        template,
        styles: [styles]
      }
    });
  }
}

export default UpdateLoginEmailModal;
